export const MedUrl =
  'https://neuronation-med.de/?utm_source=neuronation&utm_medium=subscribe&utm_campaign=top-banner-checkout';
